import { TextField as BaseTextField } from '@kvdbil/components';
import { TextFieldProps as BaseTextFieldProps } from '@kvdbil/components/types/components/Textfield';
import React, { RefObject } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue
} from 'react-hook-form';
import { ControllerRules } from '~/App/shared/interfaces/ControllerRules';

export type TextFieldProps<FormState extends FieldValues> = Omit<
  BaseTextFieldProps,
  'value'
> & {
  control: Control<FormState>;
  name: Path<FormState>;
  rules?: ControllerRules;
  defaultValue?: PathValue<FormState, Path<FormState>>;
};

const Input = React.forwardRef((props: BaseTextFieldProps, ref) => (
  <BaseTextField {...props} forwardRef={ref as RefObject<HTMLInputElement>} />
));

const TextFieldWithControl = <FormState extends FieldValues>(
  props: TextFieldProps<FormState>
) => {
  return (
    <Controller<FormState>
      {...props}
      render={({ field, fieldState }) => {
        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
          field.onBlur();
          props.onBlur?.(e);
        };

        return (
          <Input
            {...props}
            {...field}
            onBlur={handleBlur}
            value={field.value}
            errors={
              fieldState.error?.message
                ? [fieldState.error?.message]
                : undefined
            }
            hasError={Boolean(fieldState.error)}
          />
        );
      }}
    />
  );
};

export default TextFieldWithControl;
